/** Touch/Mobile → native Google-Meet-App statt Desktop-Popup. */
export function isLikelyMobileMeetClient(): boolean {
  if (typeof window === 'undefined') return false;
  const coarse = window.matchMedia?.('(pointer: coarse)')?.matches === true;
  const ua = navigator.userAgent || '';
  return coarse || /Android|iPhone|iPad|iPod|Mobile/i.test(ua);
}

const MEET_CODE_RE = /^[a-z]{3}-[a-z]{4}-[a-z]{3}$/i;

/**
 * Stellt sicher, dass Meet-/Zoom-Links absolut sind.
 * Ohne https:// landet `meet.google.com/...` relativ unter pe-one.friseur-coaching.de.
 */
export function normalizeExternalMeetUrl(raw: string): string {
  let url = String(raw || '').trim();
  if (!url) return '';

  // Falls jemand den kaputten Relativ-Pfad aus dem Browser zurückkopiert hat
  const peOneMeet = url.match(/\/(meet\.google\.com\/[^\s?#]+)/i);
  if (peOneMeet) {
    url = peOneMeet[1];
  }

  if (/^https?:\/\//i.test(url)) return url;
  if (url.startsWith('//')) return `https:${url}`;

  // Nur Meet-Code (rwy-eyiw-rxj)
  if (MEET_CODE_RE.test(url)) {
    return `https://meet.google.com/${url.toLowerCase()}`;
  }

  // Domain ohne Schema: meet.google.com/... oder zoom.us/...
  if (/^[a-z0-9.-]+\.[a-z]{2,}([/:?]|$)/i.test(url)) {
    return `https://${url}`;
  }

  return url;
}

/**
 * Desktop: Fake-Modal-Popup ohne Browserleisten (zentriert).
 * Mobile: Direktweiterleitung (Meet-App).
 */
export function openGoogleMeet(meetUrl: string): void {
  const url = normalizeExternalMeetUrl(meetUrl);
  if (!url) return;
  if (isLikelyMobileMeetClient()) {
    window.location.href = url;
    return;
  }
  const width = 1200;
  const height = 800;
  const left = window.screen.width / 2 - width / 2;
  const top = window.screen.height / 2 - height / 2;
  window.open(
    url,
    'GoogleMeetPopup',
    `width=${width},height=${height},top=${top},left=${left},menubar=no,toolbar=no,location=no,status=no,resizable=yes`
  );
}
